export default __webpack_public_path__ + "static/media/steve_trumble.548bc827.jpg";